import { css } from "@emotion/react";

export const addStyles = backgroundColor => () => css`
  width: 24px;
  background-color: ${backgroundColor};
`;
